import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Tooltip,
} from "@mui/material";

import EventNoteIcon from "@mui/icons-material/EventNote";
import ArrowRightAltIcon from "@mui/icons-material/ArrowRightAlt";
import DataSourceIcon from "../../Components/DataSourcesPanel";

const UpcomingMeetingsCard = ({ theme, upcoming }) => {
  return (
    <Card
      sx={{
        flex: 0.85,
        borderRadius: 3,
        boxShadow: "0 10px 25px rgba(15,23,42,0.10)",
        display: "flex",
        flexDirection: "column",
      }}
    >
      <CardContent sx={{ p: 3, flexGrow: 1 }}>
        <Box sx={{ display: "flex", gap: 1, mb: 1.2, alignItems: "center" }}>
          <EventNoteIcon sx={{ color: theme.palette.primary.main }} />
          <Tooltip title="Scheduled upcoming reviews and touchpoints." arrow>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 800,
                fontSize: "1.05rem",
                color: theme.palette.primary.main,
                cursor: "help",
              }}
            >
              Upcoming Meetings
            </Typography>
          </Tooltip>
          <DataSourceIcon mode="light" sources={["Salesforce Events"]} />
        </Box>

        <Box sx={{ maxHeight: { xs: "unset", lg: 290 }, overflowY: "auto" }}>
          <List dense>
            {upcoming.map((m, idx) => (
              <ListItem key={idx} sx={{ alignItems: "flex-start" }}>
                <ListItemIcon sx={{ minWidth: 26, my: "auto" }}>
                  <ArrowRightAltIcon
                    sx={{ fontSize: 16, color: theme.palette.primary.main }}
                  />
                </ListItemIcon>
                <ListItemText
                  primary={`${m.title} – ${m.date}`}
                  secondary={m.description}
                  primaryTypographyProps={{
                    fontSize: "0.82rem",
                    fontWeight: 700,
                  }}
                  secondaryTypographyProps={{
                    fontSize: "0.76rem",
                    color: "#6b7280",
                  }}
                />
              </ListItem>
            ))}
            {upcoming.length === 0 && (
              <Typography sx={{ fontSize: "0.78rem", color: "#6b7280" }}>
                —
              </Typography>
            )}
          </List>
        </Box>
      </CardContent>
    </Card>
  );
};

export default UpcomingMeetingsCard;
